import { ReactSelectOption } from '@components/controls/custom-react-select'

export const getGastroCardCode = (gastroCard: ReactSelectOption | string): string => {
  if (typeof gastroCard === 'object' && 'label' in gastroCard) return gastroCard.label
  return gastroCard
}
